export const sportIds = {
  Basketball: 59,
  Football: 111,
  Cycling: 247,
  Golf: 117,
  'Horse Racing': 248,
  Baseball: 58,
  Hockey: 122,
  'Mixed martial arts': 231,
  'Auto racing': 53,
  Soccer: 199,
  Tennis: 215,
  Boxing: 72,
  Cricket: 88,
}

export const leagueIds = {
  "Men's NCAA Basketball": 191260,
  'NCAA Football': 191261,
  '150th Kentucky Derby': 26703121,
  MLB: 191273,
  NBA: 191276,
  NFL: 191277,
  NHL: 191278,
  'Professional Fighters League': 15471095,
  NASCAR: 815400,
  'Formula 1': 691060,
  'Ligue 1': 3606627,
  'Liga MX': 9208870,
  'CONCACAF Nations League': 17567599,
  'La Liga': 3609994,
  CONMEBOL: 21865682,
  MLS: 191274,
  'US Open': 27552666,
  WNBA: 191289,
  BKFC: 10081926,
  'PGA Golf Tour': 845788,
  IPL: 3606596,
  SA20: 23818606,
  ICC: 29290904,
  'Premier League': 3605402,
  'TGL Golf': 26049265,
  'NASCAR Cup Series': 17799520,
  'NASCAR Racing': 815400,
  'Liv Golf': 22296060,
  'Masters Golf': 28817988,
  'Liga BetPlay Dimayor': 8141824,
  UCL: 3616485,
}

export const leagueGroupIds = {
  golf: [
    leagueIds['TGL Golf'],
    leagueIds['PGA Golf Tour'],
    leagueIds['Liv Golf'],
    leagueIds['Masters Golf'],
  ],
  nascar: [leagueIds['NASCAR Cup Series'], leagueIds['NASCAR Racing']],
  nba: [leagueIds['NBA'], leagueIds['WNBA']],
  cricket: [leagueIds['IPL'], leagueIds['ICC'], leagueIds['SA20']],
  canada_soccer: [leagueIds['Premier League'], leagueIds['UCL']],
}

export const teamIds = {
  'Utah Hockey Club': 65676,
  'Alabama Crimson Tide': 65,
  'Clemson Tigers': 99,
  'Colorado Buffaloes': 102,
  'Florida Gators': 121,
  'Georgia Bulldogs': 131,
  'LSU Tigers': 167,
  'Michigan Wolverines': 171,
  'Ohio State Buckeyes': 214,
  'Oklahoma Sooners': 215,
  'Oregon Ducks': 217,
  'Penn State Nittany Lions': 219,
  'Florida State Seminoles': 125,
  'USC Trojans': 274,
  'Texas Longhorns': 258,
  'Tennessee Volunteers': 255,
  'Notre Dame Fighting Irish': 212,
  'Ole Miss Rebels': 181,
  'South Carolina Gamecocks': 238,
  'Miami Hurricanes': 175,
  'Pittsburgh Pirates': 22,
  'Seattle Mariners': 25,
  'White Sox': 6,
  'Boston Red Sox': 4,
  'Arizona Diamondbacks': 1,
  'Atlanta Braves': 2,
  'Baltimore Orioles': 3,
  'Cincinnati Reds': 7,
  'Cleveland Guardians': 23385,
  'Colorado Rockies': 9,
  'Detroit Tigers': 10,
  'Kansas City Royals': 13,
  'Los Angeles Angels': 16396,
  'Miami Marlins': 6075,
  'Milwaukee Brewers': 16,
  'Minnesota Twins': 17,
  'New York Yankees': 19,
  'San Diego Padres': 23,
  'St Louis Cardinals': 26,
  'Tampa Bay Rays': 27,
  'Texas Rangers': 28,
  'Washington Nationals': 30,
  Athletics: 76180,
  'Chicago Cubs': 5,
  'Los Angeles Dodgers': 15,
  'New York Mets': 18,
  'Philadelphia Phillies': 21,
  'San Francisco Giants': 24,
  'Toronto Blue Jays': 29,
  'Houston Rockets': 409,
  'Boston Celtics': 401,
  'New York Knicks': 419,
  'Philadelphia 76ers': 421,
  'Denver Nuggets': 406,
  'Golden State Warriors': 408,
  'Sacramento Kings': 424,
  'Atlanta Hawks': 400,
  'Charlotte Hornets': 8210,
  'Cleveland Cavaliers': 404,
  'Dallas Mavericks': 405,
  'Detroit Pistons': 407,
  'Indiana Pacers': 410,
  'Los Angeles Clippers': 411,
  'Memphis Grizzlies': 413,
  'Miami Heat': 414,
  'Milwaukee Bucks': 415,
  'Minnesota Timberwolves': 416,
  'New Orleans Pelicans': 7766,
  'Oklahoma City Thunder': 426,
  'Orlando Magic': 420,
  'Phoenix Suns': 422,
  'San Antonio Spurs': 425,
  'Brooklyn Nets': 7277,
  'Los Angeles Lakers': 412,
  'Toronto Raptors': 427,
  'Washington Wizards': 429,
  'Arizona Cardinals': 31,
  'Atlanta Falcons': 32,
  'Baltimore Ravens': 33,
  'Buffalo Bills': 34,
  'Carolina Panthers': 35,
  'Chicago Bears': 36,
  'Cincinnati Bengals': 37,
  'Cleveland Browns': 38,
  'Dallas Cowboys': 39,
  'Denver Broncos': 40,
  'Detroit Lions': 41,
  'Green Bay Packers': 42,
  'Houston Texans': 43,
  'Indianapolis Colts': 44,
  'Jacksonville Jaguars': 45,
  'Kansas City Chiefs': 46,
  'Las Vegas Raiders': 20783,
  'Los Angeles Chargers': 14215,
  'Los Angeles Rams': 9690,
  'Miami Dolphins': 47,
  'Minnesota Vikings': 48,
  'New England Patriots': 49,
  'New Orleans Saints': 50,
  'New York Giants': 51,
  'New York Jets': 52,
  'Philadelphia Eagles': 54,
  'Pittsburgh Steelers': 55,
  'San Francisco 49ers': 57,
  'Seattle Seahawks': 58,
  'Tampa Bay Buccaneers': 60,
  'Tennessee Titans': 61,
  'Washington Commanders': 23731,
  'Boston Bruins': 432,
  'Pittsburgh Penguins': 453,
  'Seattle Kraken': 21209,
  'Anaheim Ducks': 430,
  'Arizona Coyotes': 8211,
  'Carolina Hurricanes': 435,
  'Columbus Blue Jackets': 438,
  'Dallas Stars': 439,
  'Detroit Red Wings': 440,
  'Florida Panthers': 442,
  'Los Angeles Kings': 443,
  'Minnesota Wild': 444,
  'Nashville Predators': 446,
  'St Louis Blues': 455,
  'Tampa Bay Lightning': 456,
  'Chicago Sky': 475,
  'Houston Astros': 12,
  'Portland Trailblazers': 423,
  'Colorado Avalanche': 437,
  'Buffalo Sabres': 433,
  'Utah Jazz': 428,
  'Chicago Bulls': 403,
  'Calgary Flames': 434,
  'Edmonton Oilers': 441,
  'Montreal Canadiens': 445,
  'New Jersey Devils': 447,
  'New York Islanders': 448,
  'New York Rangers': 449,
  'Ottawa Senators': 450,
  'Philadelphia Flyers': 451,
  'San Jose Sharks': 454,
  'Toronto Maple Leafs': 457,
  'Utah Mammoth': 460571,
  'Vancouver Canucks': 458,
  'Vegas Golden Knights': 14080,
  'Washington Capitals': 459,
  'Winnipeg Jets': 6053,
}

export const teamShortNames = {
  // NFL Teams
  31: 'Cardinals',
  32: 'Falcons',
  33: 'Ravens',
  34: 'Bills',
  35: 'Panthers',
  36: 'Bears',
  37: 'Bengals',
  38: 'Browns',
  39: 'Cowboys',
  40: 'Broncos',
  41: 'Lions',
  42: 'Packers',
  43: 'Texans',
  44: 'Colts',
  45: 'Jaguars',
  46: 'Chiefs',
  20783: 'Raiders',
  14215: 'Chargers',
  9690: 'Rams',
  47: 'Dolphins',
  48: 'Vikings',
  49: 'Patriots',
  50: 'Saints',
  51: 'Giants',
  52: 'Jets',
  54: 'Eagles',
  55: 'Steelers',
  57: '49ers',
  58: 'Seahawks',
  60: 'Buccaneers',
  61: 'Titans',
  23731: 'Commanders',

  // NHL Teams
  432: 'Bruins',
  453: 'Penguins',
  21209: 'Kraken',
  430: 'Ducks',
  8211: 'Coyotes',
  435: 'Hurricanes',
  438: 'Blue Jackets',
  439: 'Stars',
  440: 'Red Wings',
  442: 'Panthers',
  443: 'Kings',
  444: 'Wild',
  446: 'Predators',
  455: 'Blues',
  456: 'Lightning',
  437: 'Avalanche',
  433: 'Sabres',
  434: 'Flames',
  441: 'Oilers',
  445: 'Canadiens',
  447: 'Devils',
  448: 'Islanders',
  449: 'Rangers',
  450: 'Senators',
  451: 'Flyers',
  454: 'Sharks',
  457: 'Maple Leafs',
  458: 'Canucks',
  14080: 'Golden Knights',
  459: 'Capitals',
  6053: 'Jets',

  // NBA Teams
  423: 'Trailblazers',
  428: 'Jazz',
  403: 'Bulls',

  // WNBA Teams
  475: 'Sky',

  // MLB Teams
  12: 'Astros',

  // Other Sports
  460571: 'Mammoth',

  //College Football Teams
  4120: 'Wildcats',
  301: 'Grizzlies',
  9948: 'Bulldogs',
  63: 'Falcons',
  64: 'Zips',
  65: 'Crimson Tide',
  66: 'Bulldogs',
  67: 'Hornets',
  68: 'Blazers',
  69: 'Great Danes',
  5792: 'Rams',
  302: 'Britons',
  9999: 'Lions',
  70: 'Braves',
  5806: 'Saxons',
  10036: 'Pioneers',
  4153: 'Gators',
  17309: 'Yellow Jackets',
  10060: 'Scots',
  282706: 'Golden Wolves',
  5975: 'Yellow Jackets',
  5789: 'Lord Jeffs',
  10095: 'Ravens',
  303: 'Rams',
  10106: 'Amcats',
  71: 'Mountaineers',
  72: 'Wildcats',
  73: 'Sun Devils',
  74: 'Razorbacks',
  75: 'Red Wolves',
  4180: 'Wonder Boys',
  304: 'Boll Weevils',
  76: 'Golden Lions',
  77: 'Black Knights',
  10120: 'Eagles',
  305: 'Greyhounds',
  78: 'Tigers',
  15652: 'Auggies',
  10209: 'Vikings',
  10398: 'Vikings',
  10236: 'Spartans',
  10249: 'Kangaroos',
  79: 'Governors',
  10271: 'Cougars',
  90: 'Cougars',
  10297: 'Yellow Jackets',
  80: 'Cardinals',
  283008: 'Bulldogs',
  10369: 'Bobcats',
  81: 'Bears',
  5823: 'Blazers',
  10563: 'Buccaneers',
  10570: 'Beavers',
  308: 'Tigers',
  10579: 'Eagles',
  309: 'Falcons',
  10599: 'Vikings',
  9232: 'Bison',
  15653: 'Royals',
  82: 'Wildcats',
  9237: 'Yellow Jackets',
  4234: 'Huskies',
  10886: 'Big Blue',
  11750: 'Beavers',
  83: 'Broncos',
  84: 'Eagles',
  11760: 'Polar Bears',
  310: 'Bulldogs',
  85: 'Falcons',
  5974: 'Tornados',
  11831: 'Eagles',
  11796: 'Bears',
  278197: 'Golden Eagles',
  86: 'Bears',
  311: 'Bulldogs',
  87: 'Bison',
  11862: 'Beavers',
  88: 'Bulls',
  5764: 'Bengals',
  89: 'Bulldogs',
  278028: 'Kingsmen',
  91: 'Mustangs',
  93: 'Golden Bears',
  312: 'Vulcans',
  69729: 'Knights',
  313: 'Fighting Camels',
  9821: 'Crusaders',
  10655: 'Knights',
  4325: 'Tartans',
  10679: 'Pioneers',
  4326: 'Eagles',
  5753: 'Firebirds',
  5788: 'Spartans',
  10771: 'Spartans',
  9239: 'Indians',
  10871: 'Cardinals',
  314: 'Bears',
  11152: 'Dutch',
  94: 'Blue Devils',
  96: 'Chippewas',
  11122: 'Mules',
  7246: 'Bronchos',
  316: 'Marauders',
  317: 'Wildcats',
  12411: 'Colonels',
  4351: 'Eagles',
  5761: 'Panthers',
  5774: 'Golden Eagles',
  97: 'Buccaneers',
  4362: '49ers',
  12516: 'Maroons',
  318: 'Hawks',
  12566: 'Captains',
  98: 'Bearcats',
  12608: 'Stags',
  4376: 'Golden Eagles',
  319: 'Panthers',
  99: 'Tigers',
  12666: 'Bears',
  100: 'Chanticleers',
  13178: 'Kohawks',
  10537: 'Mules',
  101: 'Raiders',
  102: 'Buffaloes',
  7245: 'Mavericks',
  4405: 'Orediggers',
  103: 'Rams',
  4409: 'ThunderWolves',
  104: 'Lions',
  5822: 'Mountain Lions',
  320: 'Falcons',
  10902: 'Cougars',
  4416: 'Cobbers',
  11115: 'Golden Bears',
  105: 'Huskies',
  106: 'Big Red',
  11222: 'Rams',
  5807: 'Red Dragons',
  11238: 'Storm',
  11513: 'Colonels',
  107: 'Big Green',
  17636: 'Panthers',
  108: 'Wildcats',
  109: 'Flyers',
  9565: 'Tigers',
  282702: 'Bulldogs',
  110: "Fightin' Blue Hens",
  111: 'Hornets',
  324: 'Aggies',
  325: 'Statesmen',
  12859: 'Big Red',
  12973: 'Red Devils',
  112: 'Bulldogs',
  13287: 'Spartans',
  113: 'Blue Devils',
  114: 'Dukes',
  115: 'Pirates',
  327: 'Tigers',
  4484: 'Warriors',
  4485: 'Buccaneers',
  76424: 'Lions',
  13330: 'Tigers',
  283409: 'Eagles',
  116: 'Panthers',
  117: 'Colonels',
  118: 'Eagles',
  13376: 'Greyhounds',
  119: 'Eagles',
  4505: 'Fighting Scots',
  328: 'Tigers',
  4506: 'Vikings',
  13411: 'Bluejays',
  120: 'Phoenix',
  10140: 'Wasps',
  10143: 'Hornets',
  10145: 'Gulls',
  71231: 'Flying Fleet',
  10160: 'Red Devils',
  278260: 'Devils',
  9532: 'Fighting Falcons',
  329: 'Broncos',
  10242: 'Bulldogs',
  10263: 'Panthers',
  10272: 'Oilers',
  10307: 'Falcons',
  121: 'Gators',
  122: 'Rattlers',
  123: 'Owls',
  124: 'Golden Panthers',
  125: 'Seminoles',
  126: 'Rams',
  9307: 'Tigers',
  4554: 'Skyhawks',
  330: 'Wildcats',
  10375: 'Rams',
  331: 'Grizzlies',
  4560: 'Diplomats',
  25153: 'Ravens',
  127: 'Bulldogs',
  10461: 'Bobcats',
  128: 'Paladins',
  9852: 'Bison',
  4573: 'Golden Knights',
  129: "Runnin' Bulldogs",
  9807: 'Golden Tornadoes',
  10476: 'Bruins',
  130: 'Hoyas',
  131: 'Bulldogs',
  132: 'Eagles',
  5981: 'Panthers',
  133: 'Yellow Jackets',
  10499: 'Bullets',
  332: 'Pioneers',
  134: 'Tigers',
  10529: 'Lakers',
  10565: 'Pride',
  10575: 'Panthers',
  10586: 'Pioneers',
  10600: 'Wolverines',
  10610: 'Quakers',
  10617: 'Golden Gusties',
  10627: 'Continentals',
  10642: 'Pipers',
  10650: 'Tigers',
  135: 'Pirates',
  333: 'Panthers',
  10693: 'Cowboys',
  4616: 'Bison',
  10703: 'Hawks',
  136: 'Crimson',
  137: 'Rainbow Warriors',
  10731: 'Student Princes',
  334: 'Reddies',
  10746: 'Warriors',
  283410: 'Hawks',
  10786: 'Chargers',
  10798: 'Terriers',
  5747: 'Statesmen',
  139: 'Crusaders',
  140: 'Cougars',
  8092: 'Huskies',
  141: 'Bison',
  10846: 'Yellow Jackets',
  10852: 'Hawks',
  10860: 'Eagles',
  142: 'Vandals',
  143: 'Bengals',
  144: 'Fighting Illini',
  10913: 'Blueboys',
  145: 'Redbirds',
  10920: 'Titans',
  7980: 'Cardinals',
  146: 'Hoosiers',
  336: 'Crimson Hawks',
  147: 'Sycamores',
  8292: 'Greyhounds',
  149: 'Hawkeyes',
  150: 'Cyclones',
  5758: 'Bombers',
  151: 'Tigers',
  153: 'Gamecocks',
  154: 'Dukes',
  9799: 'Blue Streaks',
  10957: 'Blue Jays',
  337: 'Golden Bulls',
  11009: 'Eagles',
  11028: 'Hornets',
  155: 'Jayhawks',
  156: 'Wildcats',
  11031: 'Cougars',
  8792: 'Owls',
  157: 'Golden Flashes',
  158: 'Wildcats',
  5769: 'Thorobreds',
  338: 'Panthers',
  9566: 'Lords',
  283012: 'Giants',
  11105: 'Monarchs',
  11111: 'Prairie Fire',
  4738: 'Golden Bears',
  19548: 'Sharks',
  167: 'Tigers',
  11144: 'Leopards',
  11173: 'Panthers',
  160: 'Leopards',
  4746: 'Storm',
  11207: 'Foresters',
  11245: 'Muskies',
  5978: 'Cardinals',
  9242: 'Dragons',
  11020: 'Vikings',
  11094: 'Flying Dutchmen',
  161: 'Mountain Hawks',
  341: 'Bears',
  11304: 'Pioneers',
  162: 'Flames',
  11310: 'Saints',
  8293: 'Blue Tigers',
  342: 'Lions',
  11328: 'Lions',
  8526: 'Wildcats',
  343: 'Blue Bears',
  5976: 'Bald Eagles',
  11132: 'Duhawks',
  164: "Ragin' Cajuns",
  163: 'Bulldogs',
  165: 'Warhawks',
  166: 'Cardinals',
  17658: 'Norse',
  11373: 'Warriors',
  15388: 'Fighting Scots',
  11359: 'Engineers',
  11463: 'Scots',
  168: 'Black Bears',
  12124: 'Mariners',
  12472: 'Spartans',
  12534: 'Pioneers',
  169: 'Red Foxes',
  345: 'Lions',
  170: 'Thundering Herd',
  12144: 'Knights',
  13913: 'Marauders',
  12212: 'Crusaders',
  171: 'Terrapins',
  9798: 'Fighting Scots',
  172: 'Minutemen',
  12909: 'Buccaneers',
  12967: 'Green Terror',
  12995: 'Bearcats',
  13045: 'War Hawks',
  173: 'Cowboys',
  174: 'Tigers',
  8082: 'Bears',
  13473: 'Mariners',
  8250: 'Lakers',
  11018: 'Warriors',
  5748: 'Monarchs',
  175: 'Hurricanes',
  176: 'RedHawks',
  177: 'Wolverines',
  178: 'Spartans',
  11092: 'Huskies',
  179: 'Blue Raiders',
  11162: 'Panthers',
  11176: 'Mustangs',
  5754: 'Golden Bears',
  11385: 'Marauders',
  11398: 'Big Blue',
  11432: 'Majors',
  180: 'Golden Gophers',
  4881: 'Mavericks',
  12282: 'Dragons',
  5729: 'Bulldogs',
  12146: 'Cougars',
  12451: 'Beavers',
  9820: 'Cougars',
  182: 'Bulldogs',
  183: 'Delta Devils',
  184: 'Tigers',
  346: 'Miners',
  8319: 'Lions',
  185: 'Bears',
  4899: 'Griffons',
  186: 'Hawks',
  11411: 'Fighting Scots',
  187: 'Grizzlies',
  188: 'Bobcats',
  11420: 'Red Hawks',
  11453: 'Greyhounds',
  189: 'Eagles',
  348: 'Maroon Tigers',
  190: 'Bears',
  11494: 'Lions',
  8527: 'Purple Raiders',
  4932: 'Mules',
  191: 'Racers',
  11520: 'Fighting Muskies',
  202: 'Wolfpack',
  192: 'Midshipmen',
  193: 'Cornhuskers',
  11563: 'Prairie Wolves',
  4944: 'Lopers',
  194: 'Wolf Pack',
  11657: "Nor'Easters",
  195: 'Wildcats',
  6057: 'Chargers',
  196: 'Lobos',
  349: 'Cowboys',
  197: 'Aggies',
  5743: 'Wolves',
  198: 'Colonels',
  11710: 'Bison',
  199: 'Spartans',
  4979: 'Lions',
  200: 'Tar Heels',
  201: 'Aggies',
  350: 'Eagles',
  11720: 'Battling Bishops',
  11728: 'Cardinals',
  351: 'Fighting Hawks',
  203: 'Bison',
  352: 'Crusaders',
  11743: 'Vikings',
  204: 'Mean Green',
  5977: 'RiverHawks',
  206: 'Lumberjacks',
  207: 'Bears',
  208: 'Huskies',
  209: 'Panthers',
  11759: 'Wildcats',
  11762: 'Wolves',
  5025: 'Bearcats',
  210: 'Wildcats',
  5979: 'Rangers',
  211: 'Demons',
  11788: 'Eagles',
  11805: 'Timberwolves',
  11809: 'Cadets',
  212: 'Fighting Irish',
  11989: 'Yeomen',
  213: 'Bobcats',
  12006: 'Panthers',
  12010: 'Polar Bears',
  214: 'Buckeyes',
  12027: 'Battling Bishops',
  215: 'Sooners',
  12031: 'Bison',
  216: 'Cowboys',
  5741: 'Monarchs',
  181: 'Rebels',
  12043: 'Comets',
  217: 'Ducks',
  218: 'Beavers',
  12060: 'Cardinals',
  5075: 'Tigers',
  353: 'Setters',
  12201: 'Boxers',
  5782: 'Lutes',
  219: 'Nittany Lions',
  220: 'Quakers',
  5642: 'Gorillas',
  221: 'Panthers',
  12276: 'Panthers',
  12341: 'Sagehens',
  222: 'Vikings',
  25155: 'Eagles',
  223: 'Panthers',
  354: 'Blue Hose',
  224: 'Tigers',
  12378: 'Loggers',
  225: 'Boilermakers',
  355: 'Hawks',
  12881: 'Engineers',
  12719: 'Yellow Jackets',
  12723: 'Bulldogs',
  226: 'Rams',
  12926: 'Lynx',
  227: 'Owls',
  228: 'Spiders',
  12941: 'Red Hawks',
  463312: 'Maroon',
  229: 'Colonials',
  13138: 'Regents',
  49437: 'Lakers',
  13434: "Fightin' Engineers",
  13455: 'Profs',
  230: 'Scarlet Knights',
  246: 'Mustangs',
  278326: 'Privateers',
  12318: 'Mustangs',
  92: 'Hornets',
  231: 'Pioneers',
  13042: 'Cardinals',
  9236: 'Hawks',
  12775: 'Johnnies',
  12818: 'Bearcats',
  13199: 'Sea Gulls',
  13402: 'Seahawks',
  232: 'Bearkats',
  233: 'Bulldogs',
  234: 'Toreros',
  235: 'Aztecs',
  236: 'Spartans',
  237: 'Tigers',
  5821: 'Griffins',
  12907: 'Tigers',
  356: 'Bears',
  12921: 'Hornets',
  5215: 'Rams',
  5216: 'Raiders',
  9245: 'Hawks',
  13049: 'Storm',
  13063: 'Cougars',
  5226: 'The Rock',
  5980: 'Jaguars',
  238: 'Gamecocks',
  239: 'Bulldogs',
  357: 'Coyotes',
  240: 'Jackrabbits',
  17924: 'Hardrockers',
  241: 'Bulls',
  242: 'Redhawks',
  243: 'Lions',
  358: 'Savage Storm',
  244: 'Jaguars',
  5255: 'Muleriders',
  5739: 'Owls',
  245: 'Salukis',
  247: 'Golden Eagles',
  12434: 'Crimson Storm',
  248: 'Thunderbirds',
  360: 'Knights',
  361: 'Bearcats',
  12617: 'Mustangs',
  12620: 'Pirates',
  12630: 'Bulldogs',
  12728: 'Pride',
  249: 'Red Flash',
  5765: 'Cardinals',
  12811: 'Saints',
  12460: 'Green Knights',
  12481: 'Oles',
  12505: 'Saints',
  250: 'Cardinal',
  251: 'Lumberjacks',
  8093: 'Hatters',
  12760: 'Mustangs',
  366: 'Skyhawks',
  252: 'Seawolves',
  12587: 'Lobos',
  80047: 'River Hawks',
  253: 'Orange',
  278329: 'Lions',
  260: 'Horned Frogs',
  12638: 'Texans',
  254: 'Owls',
  255: 'Volunteers',
  256: 'Tigers',
  257: 'Golden Eagles',
  258: 'Longhorns',
  259: 'Aggies',
  368: 'Javelinas',
  12527: 'Bulldogs',
  261: 'Tigers',
  262: 'Bobcats',
  263: 'Red Raiders',
  264: 'Miners',
  278453: 'Falcons',
  6054: 'Roadrunners',
  265: 'Bulldogs',
  13529: 'Tomcats',
  13297: 'Saints',
  12557: 'Dragons',
  266: 'Rockets',
  267: 'Tigers',
  13169: 'Thunder',
  278343: 'Bantams',
  12307: 'Tigers',
  268: 'Trojans',
  12299: 'Bulldogs',
  9888: 'Jumbos',
  269: 'Green Wave',
  270: 'Golden Hurricane',
  370: 'Pioneers',
  371: 'Golden Tigers',
  271: 'Aggies',
  95: 'Knights',
  272: 'Bruins',
  278246: 'Corsairs',
  372: 'Braves',
  273: 'Rebels',
  274: 'Trojans',
  277: 'Mocs',
  278: 'Skyhawks',
  45344: 'Garnet Chargers',
  13085: 'Yellowjackets',
  12810: 'Tommies',
  373: 'Peacocks',
  10001: 'Bears',
  275: 'Utes',
  276: 'Aggies',
  25165: 'Trailblazers',
  10048: 'Pioneers',
  5462: 'Blazers',
  279: 'Beacons',
  280: 'Commodores',
  281: 'Wildcats',
  282: 'Cavaliers',
  283: 'Keydets',
  374: 'Trojans',
  284: 'Hokies',
  5496: 'Panthers',
  9996: 'Cavaliers',
  12077: 'Little Giants',
  285: 'Seahawks',
  286: 'Demon Deacons',
  12085: 'Cavaliers',
  12102: 'Knights',
  375: 'Ichabods',
  287: 'Huskies',
  12185: 'Presidents',
  17837: 'Bears',
  288: 'Cougars',
  10283: 'Generals',
  8944: 'Warriors',
  10161: 'Wildcats',
  10182: 'Yellow Jackets',
  289: 'Wildcats',
  10226: 'Cardinals',
  5529: 'Tigers',
  378: 'Golden Rams',
  10364: 'Argonauts',
  5532: 'Wolves',
  5820: 'Hilltoppers',
  5793: 'Buffaloes',
  290: 'Mountaineers',
  12183: 'Yellow Jackets',
  5766: 'Bobcats',
  291: 'Catamounts',
  5558: 'Mountaineers',
  12169: 'Colonials',
  292: 'Leathernecks',
  293: 'Hilltoppers',
  294: 'Broncos',
  12156: 'Golden Bears',
  5553: 'Mustangs',
  5556: 'Wolves',
  12130: 'Owls',
  12109: 'Blue Jays',
  5772: 'Titans',
  12092: 'Thunder',
  29869: 'Cardinals',
  5760: 'Pirates',
  5757: 'Pride',
  9878: 'Colonels',
  5572: 'Bearcats',
  295: 'Tribe',
  9231: 'Cardinals',
  11635: 'Pioneers',
  5790: 'Ephs',
  11612: 'Fighting Quakers',
  11604: 'Bulldogs',
  5581: 'Warriors',
  381: 'Rams',
  296: 'Badgers',
  5591: 'Warriors',
  5593: 'Blugolds',
  382: 'Eagles',
  5599: 'Titans',
  5602: 'Pioneers',
  5606: 'Falcons',
  5607: 'Pointers',
  5609: 'Blue Devils',
  5762: 'Warhawks',
  5614: 'Tigers',
  297: 'Terriers',
  10455: 'Fighting Scots',
  10639: 'Engineers',
  10657: 'Lancers',
  298: 'Cowboys',
  299: 'Bulldogs',
  300: 'Penguins',
}
